export function getCards(n: number): number[][] {
    const cards = [];

    for (let row = 0; row < n; row++) {
        // columns / diagonals
        for (let col = 0; col < n; col++) {
            let card = [];
            // rows
            card.push(row);

            // columns / diagonals
            for (let columnOffset = 0; columnOffset < n; columnOffset++) {
                card.push((columnOffset + 1) * n + (((col - (columnOffset * row)) % n) + n) % n);
            }

            cards.push(card);
        }
    }

    // extra n cards

    for (let i = 0; i <= n; i++) {
        let card = [];
        for (let j = 0; j < n; j++) {
            card.push(j + i * n);
        }
        card.push(n * (n + 1));
        cards.push(card);
    }

    // printing :)
    let result = '';
    for (let i = 0; i < cards.length; i++) {
        result += '[' + cards[i] + '], \n';
    }
    console.log(result);

    return cards;
}

export const cards7 = [
    [0,7,14,21,28,35,42,49], 
    [0,8,15,22,29,36,43,50], 
    [0,9,16,23,30,37,44,51], 
    [0,10,17,24,31,38,45,52], 
    [0,11,18,25,32,39,46,53], 
    [0,12,19,26,33,40,47,54], 
    [0,13,20,27,34,41,48,55], 
    [1,7,20,26,32,38,44,50], 
    [1,8,14,27,33,39,45,51], 
    [1,9,15,21,34,40,46,52], 
    [1,10,16,22,28,41,47,53], 
    [1,11,17,23,29,35,48,54], 
    [1,12,18,24,30,36,42,55], 
    [1,13,19,25,31,37,43,49], 
    [2,7,19,24,29,41,46,51], 
    [2,8,20,25,30,35,47,52], 
    [2,9,14,26,31,36,48,53], 
    [2,10,15,27,32,37,42,54], 
    [2,11,16,21,33,38,43,55], 
    [2,12,17,22,34,39,44,49], 
    [2,13,18,23,28,40,45,50], 
    [3,7,18,22,33,37,48,52], 
    [3,8,19,23,34,38,42,53], 
    [3,9,20,24,28,39,43,54], 
    [3,10,14,25,29,40,44,55], 
    [3,11,15,26,30,41,45,49], 
    [3,12,16,27,31,35,46,50], 
    [3,13,17,21,32,36,47,51], 
    [4,7,17,27,30,40,43,53], 
    [4,8,18,21,31,41,44,54], 
    [4,9,19,22,32,35,45,55], 
    [4,10,20,23,33,36,46,49], 
    [4,11,14,24,34,37,47,50], 
    [4,12,15,25,28,38,48,51], 
    [4,13,16,26,29,39,42,52], 
    [5,7,16,25,34,36,45,54], 
    [5,8,17,26,28,37,46,55], 
    [5,9,18,27,29,38,47,49], 
    [5,10,19,21,30,39,48,50], 
    [5,11,20,22,31,40,42,51], 
    [5,12,14,23,32,41,43,52], 
    [5,13,15,24,33,35,44,53], 
    [6,7,15,23,31,39,47,55], 
    [6,8,16,24,32,40,48,49], 
    [6,9,17,25,33,41,42,50], 
    [6,10,18,26,34,35,43,51], 
    [6,11,19,27,28,36,44,52], 
    [6,12,20,21,29,37,45,53], 
    [6,13,14,22,30,38,46,54], 
    [0,1,2,3,4,5,6,56], 
    [7,8,9,10,11,12,13,56], 
    [14,15,16,17,18,19,20,56], 
    [21,22,23,24,25,26,27,56], 
    [28,29,30,31,32,33,34,56], 
    [35,36,37,38,39,40,41,56], 
    [42,43,44,45,46,47,48,56], 
    [49,50,51,52,53,54,55,56]];
